var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"voucher-info-modal","title":_vm.$t('redeem.voucher.infotextHeading')},scopedSlots:_vm._u([{key:"modal-footer",fn:function({ hide }){return [_c('b-button',{attrs:{"variant":"default"},on:{"click":function($event){return hide()}}},[_vm._v(" "+_vm._s(_vm.$t('wgs.std.buttonClose'))+" ")])]}}]),model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.needsSpecialUKInfoText)?_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('redeem.voucher.infotextuk30pounds', {
        value: _vm.voucherValueText,
        numberOfShops: _vm.numberOfShops,
      })
    )}}):_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('redeem.voucher.infotext', {
        value: _vm.voucherValueText,
        numberOfShops: _vm.numberOfShops,
      })
    )}})])
}
var staticRenderFns = []

export { render, staticRenderFns }